import { getDataMapper, mapField, mapArray } from "@/shared";

export const mapZadarmaAtcListFromServer = mapArray(
    getDataMapper({
        pbxId: mapField("pbx_id", Number),
        numbers: mapField("numbers"),
    })
);
